import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 1.5rem 1.5rem;
`;

const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing[20]} ${theme.spacing[10]}`};
  border: 0;
  background: none;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  font-family: inherit;
  font-size: 0.875rem;
  cursor: pointer;

  &:focus-visible {
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: 0.25rem;
  }
`;

/** Full-width tappable row used as the regional settings entry in the mobile menu. */
const MenuTriggerButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing[40]} ${theme.spacing[50]}`};
  border: 0;
  background: none;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  font-family: inherit;
  font-size: 0.875rem;
  text-align: left;
  cursor: pointer;

  &:focus-visible {
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: -0.125rem;
  }
`;

export { Container, TriggerButton, MenuTriggerButton };
